/* eslint-disable @typescript-eslint/no-explicit-any */
const getDataLayer = (): unknown[] => {
  if (!(window as any).dataLayer) {
    (window as any).dataLayer = [];
  }

  return (window as any).dataLayer as unknown[];
};
export default getDataLayer;
